import { useParams } from '@tanstack/react-router'
import { FnsDetail } from '@/features/forms-and-surveys/components'
import {
  useFnsMode,
  useSurveyById,
  useFormById,
} from '@/features/forms-and-surveys/hooks'

function FormDetailPage() {
  const { formId } = useParams({
    from: '/_authenticated/forms/$formId/',
  })
  const { data, loading } = useFormById(formId)

  return <FnsDetail data={data} loading={loading} />
}

function SurveyDetailPage() {
  const { surveyId } = useParams({
    from: '/_authenticated/surveys/$surveyId/',
  })
  const { data, loading } = useSurveyById(surveyId)

  return <FnsDetail data={data} loading={loading} />
}

function FnsDetailPage() {
  const mode = useFnsMode()

  if (mode === 'survey') {
    return <SurveyDetailPage />
  }

  return <FormDetailPage />
}

export default FnsDetailPage
